import { defineMessages } from 'react-intl-next';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'third-party-query-suggestion.title',
		defaultMessage: 'Do smarter searches with {product}',
		description: 'Title shown above third-party query suggestions',
	},
	dismiss: {
		id: 'third-party-query-suggestion.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the third-party query suggestions',
	},
});
